import React, { useCallback } from 'react';
import { createUseStyles, FilePicker } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'ImagePicker');

function ImagePicker({
    label,
    title,
    subtitle,
    buttonLabel,
    cropTitle,
    cropTooltip,
    cropAcceptLabel,
    cropCancelLabel,
    fileTypes,
    value = [],
    onChange,
    classes: classesProp,
    ...props
}) {
    const { t } = useWeb5Context();
    const classes = useStyles();

    const onDrop = useCallback(
        (acceptedFiles) => {
            const finalValue = value || [];
            onChange && onChange([...finalValue, ...acceptedFiles]);
        },
        [onChange, value],
    );

    const onCrop = useCallback(
        (file, index) => {
            const files = [...value];

            files[index] = file;
            onChange && onChange(files);
        },
        [onChange, value],
    );

    const onRemove = useCallback(
        (deletedFile) => {
            onChange &&
                onChange(
                    value.filter(
                        (file) =>
                            !(
                                file.name === deletedFile.name &&
                                file.size === deletedFile.size &&
                                file.type === deletedFile.type
                            ),
                    ),
                );
        },
        [onChange, value],
    );

    return (
        <FilePicker
            label={t(label)}
            title={t(title || 'cfm_label_drag_and_drop_here')}
            subtitle={t(subtitle)}
            buttonLabel={t(buttonLabel || 'cfm_action_select_file')}
            cropTitle={t(cropTitle || 'cfm_label_crop_image')}
            cropTooltip={t(cropTooltip || 'cfm_label_crop_image')}
            cropAcceptLabel={t(cropAcceptLabel || 'cfm_action_crop')}
            cropCancelLabel={t(cropCancelLabel || 'cfm_action_cancel')}
            onCrop={onCrop}
            onDrop={onDrop}
            onRemove={onRemove}
            files={value || []}
            classes={classes}
            overrides={{ Label: { classes: { Text: 'classes.text' } } }}
            {...props}
        />
    );
}

ImagePicker.propTypes = {};

export default React.memo(ImagePicker);
